"use client";

import { c as _c } from "react/compiler-runtime";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
interface ThemeToggleProps {
  className?: string;
  size?: "default" | "compact";
}
const THEME_OPTIONS = [{
  value: "light",
  label: "Light",
  Icon: Sun
}, {
  value: "dark",
  label: "Dark",
  Icon: Moon
}, {
  value: "system",
  label: "System (default)",
  Icon: Monitor
}] as const;
export function ThemeToggle(t0) {
  const $ = _c(16);
  const {
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const {
    theme,
    setTheme
  } = useTheme();
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMounted(true);
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== className || $[3] !== mounted || $[4] !== setTheme || $[5] !== size || $[6] !== theme) {
    const sizeClasses = size === "compact" ? {
      root: "h-7 gap-0.5 p-0.5",
      button: "size-6",
      icon: "size-3.5"
    } : {
      root: "h-8 gap-1 p-1",
      button: "size-6",
      icon: "size-4"
    };
    const active = mounted ? theme ?? "system" : "system";
    t4 = "Theme";
    t5 = cn("inline-flex items-center rounded-full border border-zinc-200 bg-white transition-colors dark:border-zinc-800 dark:bg-zinc-950", sizeClasses.root, className);
    t6 = "radiogroup";
    t7 = THEME_OPTIONS.map(t8 => {
      const {
        value,
        label,
        Icon
      } = t8;
      const isActive = mounted && active === value;
      return <button aria-checked={isActive} aria-label={label} className={cn("flex items-center justify-center rounded-full transition-colors", sizeClasses.button, isActive ? "bg-zinc-100 text-zinc-900 dark:bg-zinc-800 dark:text-white" : "text-zinc-400 hover:text-zinc-700 dark:text-zinc-500 dark:hover:text-zinc-200")} key={value} onClick={() => setTheme(value)} role="radio" title={label} type="button"><Icon className={sizeClasses.icon} strokeWidth={1.5} /></button>;
    });
    $[2] = className;
    $[3] = mounted;
    $[4] = setTheme;
    $[5] = size;
    $[6] = theme;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <div aria-label={t4} className={t5} role={t6}>{t7}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}